import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_footer = _resolveComponent("v-footer")

  return (_openBlock(), _createBlock(_component_v_footer, {
    class: "pa-0",
    color: "primary"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "center",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerLinks, (link) => {
            return (_openBlock(), _createBlock(_component_v_btn, {
              key: link.name,
              to: { name: link.name },
              target: link.target,
              disabled: _ctx.$store.getters.loading,
              class: "text-none",
              size: "large",
              variant: "plain"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(link.label)), 1)
              ]),
              _: 2
            }, 1032, ["to", "target", "disabled"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}